var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6,8.77l-1.57,1.81c-.8-.69-1.67-1.29-2.6-1.79l1.61-1.84c.91.52,1.77,1.13,2.56,1.82ZM14.27,13.54c1.06.32,2.02.87,2.83,1.57l1.57-1.81c-.8-.7-1.71-1.28-2.71-1.7l-1.7,1.94ZM11.36,16.86l-1.48,1.69,2.12,2.45,2.74-3.16c-.74-.64-1.69-1.04-2.74-1.04-.22,0-.43.03-.64.06ZM20,3.79l-1.81-1.58-2.63,3c-1.15-.26-2.34-.41-3.57-.41-4.05,0-7.75,1.51-10.6,3.97l1.57,1.81c2.42-2.1,5.57-3.39,9.03-3.39.58,0,1.16.05,1.72.12l-3.14,3.59c-1.99.28-3.8,1.13-5.25,2.39l1.57,1.81s0,0,0,0l-2.85,3.25,1.21,1.06.6.52,13.64-15.57.5-.58Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOffline);
export default __webpack_public_path__ + "static/1773309961/media/icon-offline.5d55f937266db34709d9645329b17034.svg";
export { ForwardRef as ReactComponent };